export default __webpack_public_path__ + "5f146dd298b3e1db20b46407b230ca49.png";